import React from "react";
import ViewEmployeeDocumentsStyles from "./ViewEmployeeDocuments.styles";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import { Box } from "@mui/system";
import { Grid, Typography } from "@mui/material";
interface CustomProps {
  nextStep?: () => void | undefined;
  backStep?: () => void | undefined;
  handleCloseProfile?: () => void | undefined;
}

const ViewEmployeeDocuments = (props: CustomProps) => {
  const classes = ViewEmployeeDocumentsStyles;
  return (
    <>
      <Box sx={classes.contentWrapper}>
        <Box sx={classes.pageInfoHeader}>
          <Typography sx={classes.Heading}>Employee Documents</Typography>
          <Typography sx={classes.text}>
            Update your own information for the platform
          </Typography>
        </Box>
        <Grid container>
          <Box sx={classes.profileDetails}>
            <Grid container rowSpacing={3}>
              <Grid item xs={12}>
                <Typography sx={classes.detailsHeading}>Documents</Typography>
                <Typography sx={classes.subHeading}>
                  Manage your documents information to use the platform
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>PAN Card</Typography>
                <Typography sx={classes.userDetails}>pan-151327.jpg</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Passport</Typography>
                <Typography sx={classes.userDetails}>
                  passport-I151327.jpg
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Medical Card</Typography>
                <Typography sx={classes.userDetails}>med-151327.jpg</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Voter ID Card</Typography>
                <Typography sx={classes.userDetails}>
                  VID-I151327.jpg
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Other Documents</Typography>
                <Typography sx={classes.userDetails}>
                  covid-151327.jpg
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Grid item xs={4}>
            <Box sx={classes.buttonWarapper}>
              <CustomButton
                label="Back"
                buttonType="secondaryBtn"
                onClick={() => {
                  props.backStep?.();
                }}
              />
              <CustomButton
                label="Next"
                buttonType="primaryBtn"
                onClick={() => {
                  props.nextStep?.();
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ViewEmployeeDocuments;
